module.exports = __webpack_public_path__ + "img/1-movie-icon.fa828600.svg";